const React = require('react');
const FetchContext = require('./context');
const HopsResponseError = require('./hops-response-error');

const withFetch = (WrappedComponent) => {
  const Comp = class extends React.Component {
    render() {
      return React.createElement(FetchContext.Consumer, {}, ({ fetch }) =>
        React.createElement(WrappedComponent, { fetch, ...this.props })
      );
    }
  };
  Comp.displayName = `withFetch(${WrappedComponent.displayName || 'Generic'})`;
  return Comp;
};

const withFetchJson = (WrappedComponent) => {
  const Comp = class extends React.Component {
    render() {
      return React.createElement(FetchContext.Consumer, {}, ({ fetchJson }) =>
        React.createElement(WrappedComponent, { fetchJson, ...this.props })
      );
    }
  };
  Comp.displayName = `withFetchJson(${WrappedComponent.displayName ||
    'Generic'})`;
  return Comp;
};

module.exports = {
  withFetch,
  withFetchJson,
  HopsResponseError,
  FetchContext,
};
